module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAV0lEQVQ4je3QsQ3AIBAEwYUuHFEPdditG+hiHZvEEpAg+aQLf6R71KwWx1PUHNQCHMylBtVJBIC4AtkHSkD4aOqP9nj2P+2dPaYNQ3WB0yJwAW0CuYHzAQNaYED0PjVsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/master/ico4.png
// module id = YxZC
// module chunks = 11